// deps
import React, { useContext, useMemo } from "react";

// internal-deps
import { CardGroup, ICardPaymentGroup } from "@swiggy-private/payment-ui";

// interfaces
import { PaymentGroupHandlerProps } from "@payment-client/components/show-payments/components/payment-group-handler/interfaces";

// hooks
import { useCardHandler } from "@payment-client/components/show-payments/components/payment-group-handler/hooks/UseCardHandler";
import { JuspayContext } from "@payment-client/contexts/JuspayContext";
import { getJuspaySdkFeatureAvailability } from "@payment-client/helpers/JuspayHelpers";

export interface CardGroupHandlerProps extends Omit<PaymentGroupHandlerProps, "paymentGroup"> {
    paymentGroup: ICardPaymentGroup["paymentData"];
    groupTitle?: string;
    payCtaText?: string;
    cardGroupCotainerClassName?: string;
    payCtaClassName?: string;
}

export function CardGroupHandler(props: CardGroupHandlerProps): React.ReactElement | null {
    const { onSelect, onPay, paymentGroup, juspayMeta, ...otherProps } = props;
    const { paymentActions } = useCardHandler(props);

    //sdk available for CARD
    const { isSdkAvailable, featuresAvailability } = useContext(JuspayContext);

    const isSdkAvailablForeCard = useMemo(() => {
        return getJuspaySdkFeatureAvailability(props.paymentGroup.groupName, isSdkAvailable, featuresAvailability);
    }, [featuresAvailability, isSdkAvailable, props.paymentGroup.groupName]);

    return (
        <CardGroup
            paymentActions={paymentActions}
            paymentData={props.paymentGroup}
            isSdkAvailable={isSdkAvailablForeCard}
            juspayMeta={juspayMeta}
            {...otherProps}
        />
    );
}
